import React, { JSX } from 'react';
import { styled } from '@mui/material';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';

interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps): JSX.Element => {
  const { expand: _expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme }) => ({
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
  variants: [
    {
      props: ({ expand }): boolean => !expand,
      style: {
        transform: 'rotate(0deg)',
      },
    },
    {
      props: ({ expand }): boolean => !!expand,
      style: {
        transform: 'rotate(180deg)',
      },
    },
  ],
}));

export { ExpandMore };
